import React from 'react';
import { Grid2x2Icon, ListIcon, LayoutGridIcon, Settings2Icon } from 'lucide-react';
type ViewMode = 'cards' | 'list' | 'tiles';
interface ViewToggleProps {
  current: ViewMode;
  onChange: (mode: ViewMode) => void;
  onCustomizeClick: () => void;
  isCustomizing: boolean;
}
export const ViewToggle = ({
  current,
  onChange,
  onCustomizeClick,
  isCustomizing
}: ViewToggleProps) => {
  // Only show desktop view options now
  return <div className="hidden md:flex items-center space-x-2" data-id="element-333">
      <div className="flex items-center bg-gray-100 rounded-lg p-1" data-id="element-334">
        <button className={`p-2 rounded group relative ${current === 'cards' ? 'bg-white shadow text-indigo-600' : 'text-gray-600'}`} onClick={() => onChange('cards')} data-id="element-335">
          <LayoutGridIcon className="h-5 w-5" data-id="element-336" />
          <span className="sr-only" data-id="element-337">Card View</span>
        </button>
        <button className={`p-2 rounded group relative ${current === 'list' ? 'bg-white shadow text-indigo-600' : 'text-gray-600'}`} onClick={() => onChange('list')} data-id="element-338">
          <ListIcon className="h-5 w-5" data-id="element-339" />
          <span className="sr-only" data-id="element-340">List View</span>
        </button>
        <button className={`p-2 rounded group relative ${current === 'tiles' ? 'bg-white shadow text-indigo-600' : 'text-gray-600'}`} onClick={() => onChange('tiles')} data-id="element-341">
          <Grid2x2Icon className="h-5 w-5" data-id="element-342" />
          <span className="sr-only" data-id="element-343">Tile View</span>
        </button>
      </div>
      <button onClick={onCustomizeClick} className={`p-2 rounded hover:bg-gray-100 group relative ${isCustomizing ? 'text-indigo-600 bg-gray-100' : 'text-gray-600'}`} data-id="element-344">
        <Settings2Icon className="h-5 w-5" data-id="element-345" />
        <span className="sr-only" data-id="element-346">
          {isCustomizing ? 'Exit Customize Mode' : 'Customize Apps'}
        </span>
      </button>
    </div>;
};